import * as React from "react";
import { style } from "typestyle";

export interface Props {}

const styles = {
    root: style({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
    }),
};

export default class FlexCenter extends React.Component<Props, {}> {
    public render() {
        return <div className={styles.root}>{this.props.children}</div>;
    }
}
